import { Zap, ShieldCheck, Truck, Factory } from "lucide-react";

const items = [
  { icon: Zap, label: "Fast Turnaround", value: "1-2 week lead time" },
  { icon: Factory, label: "Any Scale", value: "1 piece → 1,000+" },
  { icon: ShieldCheck, label: "Tight Tolerances", value: "±0.010\" precision" },
  { icon: Truck, label: "Nationwide Shipping", value: "Ships from SoCal" },
];

export default function TrustStrip() {
  return (
    <section
      className="border-b border-zinc-800 bg-zinc-950"
      data-testid="trust-strip"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
        {items.map(({ icon: Icon, label, value }, i) => (
          <div
            key={label}
            className={`flex items-center gap-4 border-zinc-800 p-6 lg:p-8 ${
              i < 3 ? "border-b lg:border-b-0 lg:border-r" : "border-b lg:border-b-0"
            } ${i === 0 || i === 2 ? "border-r lg:border-r" : ""}`}
            data-testid={`trust-item-${i}`}
          >
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center border border-orange-600 bg-orange-600/10">
              <Icon className="h-6 w-6 text-orange-500" strokeWidth={2.5} />
            </div>
            <div>
              <p className="font-mono-spec text-zinc-500">{label}</p>
              <p className="font-display text-xl text-white sm:text-2xl">{value}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
